import { buildSelector } from '@/shared/lib/store';

export const [useViewerFullName] = buildSelector((state) =>
    state.viewer?.data?.first_name && state.viewer?.data?.last_name
        ? `${state.viewer?.data?.first_name} ${state.viewer?.data?.last_name}`
        : '',
);
